module.exports = __webpack_public_path__ + "static/Tacos-Picosos-736-W-2nd-St-Mercedes-TX-78570-9ff6b19b2c75707cc421abf94c8a37e1.png";